import * as Actions from '../actions';

const initialState = {
    timeTaken: 0,
    maxTime: 0,
    onFinish: () => {},
}

const timerReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.RESET_TIMER):
        {
            return {
                ...initialState
            }
        }

        case (Actions.TICK_TIMER):
        {
            return {
                ...state,
                timeTaken: state.timeTaken + 1
            }
        }

        case (Actions.SET_MAX_TIME):
        {
            return {
                ...state,
                maxTime: action.payload
            }
        }

        case (Actions.SET_ON_FINISH):
        {
            return {
                ...state,
                onFinish: action.payload
            }
        }

        default:
        {
            return state;
        }

    }
}

export default timerReducer;


// WEBPACK FOOTER //
// src/main/components/timer/store/reducers/timer.reducer.js